import { render, staticRenderFns } from "./giftCardScannerComponent.vue?vue&type=template&id=24c64811&scoped=true"
import script from "./giftCardScannerComponent.vue?vue&type=script&lang=js"
export * from "./giftCardScannerComponent.vue?vue&type=script&lang=js"
import style0 from "./giftCardScannerComponent.vue?vue&type=style&index=0&id=24c64811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c64811",
  null
  
)

export default component.exports